// export const server = "http://localhost:8080/api/v1";
export const server = "https://social-media-backend-woad.vercel.app/api/v1"